"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var services_1 = require("stremio/services");
var components_1 = require("../../components");
var User_less_1 = __importDefault(require("./User.less"));
var User = function (_a) {
    var profile = _a.profile;
    var t = (0, react_i18next_1.useTranslation)().t;
    var core = (0, services_1.useServices)().core;
    var avatar = (0, react_1.useMemo)(function () { return (!profile.auth ?
        "url('".concat(require('/assets/images/logo-stremlink.png'), "')")
        :
            profile.auth.user.avatar ?
                "url('".concat(profile.auth.user.avatar, "')")
                :
                    "url('".concat(require('/assets/images/logo-stremlink.png'), "')")); }, [profile.auth]);
    var onLogout = (0, react_1.useCallback)(function () {
        core.transport.dispatch({
            action: 'Ctx',
            args: {
                action: 'Logout'
            }
        });
    }, []);
    return (react_1.default.createElement("div", { className: User_less_1.default['user'] },
        react_1.default.createElement("div", { className: User_less_1.default['user-info-content'] },
            react_1.default.createElement("div", { className: User_less_1.default['avatar-container'], style: { backgroundImage: avatar } }),
            react_1.default.createElement("div", { className: User_less_1.default['email-logout-container'] },
                react_1.default.createElement("div", { className: User_less_1.default['email-label-container'], title: profile.auth === null ? t('ANONYMOUS_USER') : profile.auth.user.email },
                    react_1.default.createElement("div", { className: User_less_1.default['email-label'] }, profile.auth === null ? t('ANONYMOUS_USER') : profile.auth.user.email)),
                profile.auth !== null ?
                    react_1.default.createElement(components_1.Link, { label: t('LOG_OUT'), onClick: onLogout })
                    :
                        react_1.default.createElement(components_1.Link, { label: "".concat(t('LOG_IN'), " / ").concat(t('SIGN_UP')), href: '#/intro', target: '_self' })))));
};
exports.default = User;
